import React from 'react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

// Asked before a new Apple/Google sign-in creates an account (stops Hide My Email duplicates).
export const AccountChoiceDialog = ({ provider, open, busy, onCreate, onExisting }) => {
  const label = provider === 'apple' ? 'Apple ID' : 'Google account';
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onExisting(false)}>
      <DialogContent className="bg-[#252528] border-white/10 text-[#DCD3CA] rounded-3xl" data-testid="account-choice-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#DCD3CA]">New to Future Self?</DialogTitle>
          <DialogDescription className="text-[#B5B1AB]">
            This {label} isn't connected to a Future Self account yet. If you already have one,
            sign in to it first and connect this {label} in Settings → Sign-in methods.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-3 sm:flex-col">
          <Button
            onClick={() => onExisting(true)}
            disabled={busy}
            variant="outline"
            className="w-full rounded-2xl py-6 border-[#8BAA9E]/40 text-[#DCD3CA] hover:bg-[#8BAA9E]/10"
            data-testid="account-choice-existing-btn"
          >
            I already have an account
          </Button>
          <Button
            onClick={onCreate}
            disabled={busy}
            className="w-full rounded-2xl py-6 bg-[#8BAA9E] text-[#1C1C1E] hover:bg-[#9DBBAF]"
            data-testid="account-choice-create-btn"
          >
            {busy ? 'Creating…' : 'Create a new account'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AccountChoiceDialog;
